<template>
  <div class="rc-combobox">
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <!-- 使用el-select会导致下拉框层级太高，点击了无法打开属性面板 -->
      <el-input :class="{onlyread:component.properties.readonly}" :placeholder="initComponent.properties.placeholder" disabled>
        <i class="el-icon-arrow-down el-input__icon" slot="suffix"></i>
      </el-input>
    </div>
  </div>
</template>

<script>
import { componentMixin, dataSourceMixin } from '../mixins'
export default {
  name: 'rc-combobox',
  props: ['initComponent'],
  mixins: [ componentMixin, dataSourceMixin ],
  data () {
    // todo:下拉框 改数据源需同步修改报表
    return {
      component: this.initComponent
    }
  }

}
</script>

<style lang="scss">
  .rc-combobox {
    div.el-select {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/combobox/rc-combobox.vue